<template>
  <footer>
    <div id="abbr-rules">
      <div class="container">
        <div class="py-5 text-center">
          <div v-html="$t('Footer.legalrules')"></div>
        </div>
      </div>
    </div>
    <!-- Blue Bar Footer -->
    <div class="navbar brand-bgcolor">
      <div class="container d-flex flex-column flex-md-row justify-content-between align-items-md-start py-0">
        <div class="footer-left-content mb-3 mb-md-0 text-center text-md-start">
          <ul class="list-inline mb-2 d-flex flex-wrap justify-content-center justify-content-md-start" id="footer-nav">
            <li class="list-inline-item ps-0" v-html="$t('Footer.T&CLink')"></li>
            <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')"></li>
            <li class="list-inline-item">
              <a href="https://www.snipp.com/contact-us" target="_blank" title="Contact Us">{{
                $t('Footer.ContactUsLink')
              }}</a>
            </li>
            <li class="list-inline-item">
              <a href="mailto:customercare@website.com?subject=Do not Sell My information. Campaign - Demo Snipp Offers&amp;body=Please do not sell my information">Do Not Sell or Share My Personal Information</a>
            </li>
          </ul>
          <p class="mb-0 text-white text-center text-md-start">
            <small>Copyright© YYYY. All Rights Reserved.</small>
          </p>
        </div>
        <div class="footer-right-content d-flex justify-content-center">
          <div class="footer-social-nav">
            <ul class="list-inline m-0 d-flex align-items-center">
              <li>
                <p class="mb-0 text-white font-weight-bold">Follow Us</p>
              </li>
              <li>
                <a href="https://www.facebook.com/SnippInc/" class="fb-link social-icon" title="facebook" target="_blank">
                  <i class="fab fa-facebook"></i>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/SnippInc" class="x-link social-icon" title="twitter" target="_blank">
                  <i class="fab fa-x-twitter"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/snippinc/" class="ig-link social-icon" title="instagram" target="_blank">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/snippinteractive" class="yt-link social-icon" title="youtube" target="_blank">
                  <i class="fab fa-youtube"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  // mounted() {
  //   // Dynamically fetch the translated modelHash
  //   const modelHash = this.$t('YounetmodelHash');
  //   const modelImgurl = this.$t('YounetmodelIMg');
  //   const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;
  //   // Dynamically create the script element
  //   const script = document.createElement('script');
  //   script.type = 'module';
  //   script.src = scriptUrl;
  //   // Append the script to the body
  //   document.body.appendChild(script);
  // },
};
</script>
